import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authSlice from "../slice/authSlice";
import commonSlice from "../slice/commonSlice";
import userSlice from "../slice/userSlice";
import roleSlice from "../slice/roleSlice";
import taxSlice from "../slice/taxSlice";
import serviceSlice from "../slice/serviceSlice";
import partiSlice from "../slice/partiSlice";
import invoiceSlice from "../slice/invoiceSlice";
import entrybookSlice from "../slice/entrybookSlice";
import billSlice from "../slice/billSlice";
import portfolioSlice from "../slice/portfolioSlice";
import dashboardSlice from "../slice/dashboardSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  common: commonSlice,
  user: userSlice,
  role: roleSlice,
  tax: taxSlice,
  service: serviceSlice,
  parti: partiSlice,
  invoice: invoiceSlice,
  entryBook: entrybookSlice,
  bill: billSlice,
  portfolio: portfolioSlice,
  dashboard: dashboardSlice,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.REACT_APP_NODE_ENV !== "production",
});

export const persister = persistStore(store);
